<script>
import axios from "axios";
import Site from '@components/site.vue'
import SearchItemTemplate from '@components/search-item.vue'
import { authComputed } from '@state/helpers'

export default {
    components: { Site },
    props: {
        displayMode: {
            type: String,
            default: 'full',
        },
        showProtocolLink: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            sites: [],
            nextPage: 1,
            hasNext: false,
            searchItem: null,
            searchItems: [],
            searchItemTemplate: SearchItemTemplate,
        }
    },
    computed: {
        listClass: function () {
            const classes = [
                this.$style.list,
                (this.displayMode === 'minimal') ? this.$style.minimal : '',
            ];

            return classes;
        },
        ...authComputed,
    },
    mounted() {
        this.requestSites()
    },
    methods: {
        requestSites: function () {
            axios
                .get('/api/v2/projects', {
                    params: {
                        page: this.nextPage,
                        'filter[systemtype]': 'RED',
                        'filter[has_active_systems]': true,
                        sort: 'name',
                    },
                })
                .then((projectsResponse) => {
                    const flattened = [].concat(...projectsResponse.data.data.map(p => p.sites));

                    const siteList = flattened.filter(s => s.system_types.includes('RED'));

                    axios.get('/api/v2/sites', {
                        params: {
                            'filter[uuid]': siteList.map(s => s.uuid).join(','),
                            include: 'currentSystems.systemType',
                            perPage: 1000,
                        },
                    }).then((sitesResponse) => {
                        const sites = sitesResponse.data.data.map(site => {
                            site.systems = site.systems.filter((s) => s.system_type === 'RED')
                                .map((s) => {
                                    s.name = s.name.replace(/^ufo ?/i, '');

                                    return s;
                                });

                            return site;
                        });

                        const sorted = [...sites].sort((a, b) => {
                            return a.name.localeCompare(b.name);
                        });

                        this.sites = this.sites.concat(sorted);

                        if (projectsResponse.data.meta.current_page < projectsResponse.data.meta.last_page) {
                            this.hasNext = true;
                            this.nextPage += 1;
                        } else {
                            this.hasNext = false;
                        }
                    });
                })
                .catch(() => {
                    this.$eventBus.$emit(
                        'global-error',
                        'Something went wrong. Unable to load projects. Please try again by refreshing the page or contact our support'
                    )
                })
        },
        getSearchLabel(item) {
            return item.name
        },
        updateSearchItems(text) {
            axios.get(`/api/v2/systems?filter[systemtype]=RED&filter[name]=` + text).then((response) => {
                this.searchItems = response.data.data;
            })
        },
        clickedSearchItem(item) {
            if (item) {
                this.$router.push({ name: 'camera', params: { id: item.uuid } })
            }
        },
    },
}
</script>

<template>
    <div :class="listClass.join(' ')">
        <v-autocomplete v-if="currentUser.company_name === ''" v-model="searchItem" :items="searchItems"
            :get-label="getSearchLabel" :component-item='searchItemTemplate' :auto-select-one-item="false"
            :input-attrs="{ placeholder: 'Search for an UFO (min 3 characters)' }" @update-items="updateSearchItems"
            @item-clicked="clickedSearchItem" @input="clickedSearchItem"></v-autocomplete>
        <Site v-for="(site, index) in sites" :key="'site_' + site.uuid" :site="site" :index="index"
            :expanded="sites.length < 5" :show-protocol-link="showProtocolLink"></Site>
        <div v-if="hasNext" :class="$style.actions">
            <a href="javascript:void(0)" :class="$style.loadMore" @click="requestSites">Load more sites</a>
        </div>
    </div>
</template>

<style lang="scss" module>
@import '@design';

.list {
    width: 100%;
    max-width: 934px;
    margin: 0 auto;

    .actions {
        display: flex;
        justify-content: center;
        margin-top: 50px;

        .loadMore {
            display: flex;
            align-items: center;
            justify-content: center;
            width: auto;
            height: 48px;
            padding: 0 19px;
            font-size: 15px;
            color: $color-button-text;
            text-align: left;
            text-decoration: none;
            background: $color-button-bg;
            background-image: $color-button-bg-gradient;
            border-radius: 9999px;
            transition: all 0.5s ease;

            &:hover {
                background: $color-button-bg;
                background-image: none;
            }
        }
    }
}
</style>
